@use '../../../common/styles/variables' as *;
@use '../../../common/mixins/buttons' as *;

:host {
  display: flex;
  flex-direction: column;
  overflow: visible;
  border-radius: var(--nylas-border-radius-2x);
  width: fit-content;
  background: var(--nylas-base-0);
  position: relative;
  box-shadow: 0px 0px 6px -2px rgba(0, 0, 0, 0.05),
  0px 5px 15px -3px rgba(0, 0, 0, 0.1);
  @include default-css-variables;

  nylas-notification {
    position: absolute;
    top: 0;
    right: 0;
  }

  @media #{$mobile} {
    width: -moz-available;
    /* WebKit-based browsers will ignore this. */
    width: -webkit-fill-available;
    /* Mozilla-based browsers will ignore this. */
    width: fill-available;
    min-width: 325px;
  }
}

div.scheduler-editor-content {
  height: 800px;
  @media #{$mobile} {
    height: auto;
  }
  slot[name="login-required"] {
    height: inherit;
  }
}

div.scheduler-editor-content--group {
  height: 800px;

  @media #{$mobile} {
    height: auto;
  }
}

div.scheduler-editor-header {
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid var(--nylas-base-200);
  color: var(--nylas-base-900);
  min-width: 924px;

  @media #{$mobile} {
    width: auto;
    min-width: calc(325px - 1rem);
  }

  h1.scheduler-editor-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }

  button {
    @include invisible-button;
    color: var(--nylas-base-900);
  }

  div.language {
    select-dropdown::part(sd_dropdown-button) {
      border: none;
      padding: 4px;
      margin-right: 8px;

      &:hover {
        outline: none;
        color: var(--nylas-primary);
      }
    }

    select-dropdown::part(sd_dropdown-content) {
      min-width: 132px;
    }

    @media #{$mobile} {
      select-dropdown::part(sd_dropdown-content) {
        width: -webkit-fill-available;
        width: fill-available;
        width: -moz-available;
      }
    }
  }
}

nylas-select-event-type {
  height: inherit;
  width: calc(924px + 2rem); // 1rem padding on each side

  @media #{$mobile} {
    width: auto;
  }
}

nylas-editor-tabs,
nylas-editor-tabs-group {
  width: auto;
  height: inherit;

  .row {
    display: flex;
    gap: 1rem;
  }

  .composable {
    height: inherit;
    overflow: auto;
  }

  nylas-event-info,
  nylas-event-limits {
    div[slot='inputs'] {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  }
}

.card {
  display: flex;
  flex-direction: column;
  padding: 2rem;
  background-color: var(--nylas-base-0);
  border: 1px solid var(--nylas-base-200);
  border-radius: 5px;
  color: var(--nylas-base-900);
  max-width: fit-content;

  align-self: center;
}

.login-required {
  height: inherit;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 1rem;
  background-color: var(--nylas-base-25);
  border-radius: var(--nylas-border-radius-2x);

  .login-error-banner {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
    background-color: var(--nylas-error-50, #fef2f2);
    border: 1px solid var(--nylas-error-200, #fecaca);
    border-radius: 5px;
    color: var(--nylas-error-700, #b91c1c);
    font-size: 0.875rem;
    line-height: 1.25rem;

    svg {
      flex-shrink: 0;
      color: var(--nylas-error-500, #ef4444);
    }
  }

  p {
    margin: 0 0 1rem;
  }

  .microsoft-button,
  .google-button {
    @include button;
    display: flex;
    margin-bottom: 1rem;
    background-color: var(--nylas-base-0);
    border: 1px solid var(--nylas-base-200);
    border-radius: 5px;
    justify-content: center;
    gap: 0.5rem;
    align-items: center;
    color: var(--nylas-base-900);

    &:hover {
      background-color: var(--nylas-base-25);
    }
  }

  .other-provider-button {
    @include button;
    display: flex;
    border: 0;
    background-color: var(--nylas-base-0);
    height: 48px;
    margin-bottom: 1rem;
    font-size: 0.95rem;
    justify-content: center;
    gap: 0.25rem;
    align-items: center;
    color: var(--nylas-base-900);

    svg {
      transform: rotate(180deg);
    }

    &:hover {
      background-color: var(--nylas-base-25);
    }
  }

  .disclaimer-text {
    font-size: 0.75rem;
    color: var(--nylas-base-600);
    align-self: center;
  }

  @media #{$mobile} {
    height: auto;
  }
}

.list-configurations {
  padding: 2rem;
  height: inherit;
  background: var(--nylas-base-25);
  border-radius: var(--nylas-border-radius-2x);

  nylas-list-configurations {
    height: inherit;
    display: flex;
    flex-direction: column;
  }

  @media #{$mobile} {
    height: auto;
    padding: 2rem 1rem;
  }
}